import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequirePermission } from "@/components/universal/require-permission";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_admin")({
  component: AdminLayout,
});

function AdminLayout() {
  return (
    <RequirePermission
      permission="administrate_legrande"
      fallback={<NotFoundPage />}
    >
      <Outlet />
    </RequirePermission>
  );
}
